import { render, staticRenderFns } from "./RecipeRecordList.vue?vue&type=template&id=72d57190&scoped=true"
import script from "./RecipeRecordList.vue?vue&type=script&lang=js"
export * from "./RecipeRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d57190",
  null
  
)

export default component.exports